import React, { useState } from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { HomeNav } from '../Common/Home/HomeNav';
import { Results } from './Results/Results';
import { Regulation } from './Regulation/Regulation';
import { Calls } from './Calls/Calls';

function DashBoardSamu() {
    const queryClient = new QueryClient();
    const [activeIndex, setActiveIndex] = useState(1);

    const renderPage = (index) => {
        switch (index) {
            case 1:
                return <Results setActiveIndex={setActiveIndex} />;
            case 2:
                return <Calls setActiveIndex={setActiveIndex} />;
            case 3:
                return <Regulation setActiveIndex={setActiveIndex} />;
            default:
                return <Results setActiveIndex={setActiveIndex} />;
        }
    };

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <HomeNav
                menus={menus}
                setActiveIndex={setActiveIndex}
                activeIndex={activeIndex}
            />
            <div>{renderPage(activeIndex)}</div>
        </QueryClientProvider>
    );
}

export default DashBoardSamu;
